import styled from "@emotion/styled";

export const APIErrorFaceBoxWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	margin: 0,
	maxWidth: "474px",
	width: "100%",
	boxSizing: "border-box",
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	gap: "24px",
	color: theme.project.colors.fontColors.main,
	h1: { ...theme.project.typography.heading.h6, textAlign: "center", margin: 0 },
	p: { ...theme.project.typography.body.body1, textAlign: "center", margin: 0 },
	span: { ...theme.project.typography.caption },
	"> div:first-of-type": {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: "10px"
	},
	button: {
		width: "343px",
		maxWidth: "100%"
	}
}));
